import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BallotConfiguration {
  EnableVotingPostBallotClosed: boolean,
  EnableVotingBeforeBallotClosed: boolean,
  EnableVotingAfterBallotEndDate: boolean,
  VotingFirstRemindersInDays: number,
  VotingSecondRemindersInDays: number,
  VotingThirdRemindersInDays: number,
  BallotLevel: any,
  BallotType: any,
  BallotSubType: any,
  RecordType: any,
  RecordSubType: any,
  AccreditationBody: any,
  AllowUsersToAddRemoveRecords: boolean,
  AllowUsersToAddRemoveCommittees: boolean,
  DurationToAllowWithdrawDisapproval: number,
  Disclaimer: null | string,
  BallotConfigurationMembershipPositions: any,
  Id: string,
  TenantId: any,
  Active: boolean,
  Deleted: boolean,
  CreatedBy: string,
  ModifiedBy: string,
  CreatedDate: string,
  ModifiedDate: string,
  IsDirty: boolean,
  IsNew: boolean,
  Success: boolean,
  SysMessages: null,
  SysMessagesKey: null,
  SysMessagesType: null,
  [key: string]: any; // For additional dynamic properties
}

interface BallotState {
  selectedBallotConfiguation: BallotConfiguration | null;
}

const initialState: BallotState = {
  selectedBallotConfiguation: null,
};

const selectedBallotConfigurationSlice = createSlice({
  name: "approvalCriteria",
  initialState,
  reducers: {
    setBallotConfiguration: (state, action: PayloadAction<BallotConfiguration>) => {
      state.selectedBallotConfiguation = action.payload;
    },
    updateSelectedBallotField: (
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) => {
      if (state.selectedBallotConfiguation) {
        state.selectedBallotConfiguation[action.payload.field] = action.payload.value;
      }
    },
    clearBallotDetails: (state) => {
      state.selectedBallotConfiguation = null;
    },
  },
});

export const { setBallotConfiguration, clearBallotDetails } =
  selectedBallotConfigurationSlice.actions;

export default selectedBallotConfigurationSlice.reducer;